(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6646],{

/***/ 47441:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-pop-new.386a2ae7.png","height":101,"width":309,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEXoMETtW2vnJjvmHTPnJjvpOUzuaHbrUGBAgm5hAAAABHRSTlP7/ol5njZDfAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5JREFUeJxjYGBlAAJWJgZ2NkZGIGICclhYWBhYmAEC+QA+asKJuwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 76565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./src/styles/forgotpassword.module.scss
var forgotpassword_module = __webpack_require__(6231);
var forgotpassword_module_default = /*#__PURE__*/__webpack_require__.n(forgotpassword_module);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/components/auth/forgot-password-form.tsx













var ForgotPasswordForm = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(1), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var otpFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            mobile: ""
        },
        validationSchema: yup_es/* object */.Ry({
            mobile: yup_es/* string */.Z_().required("Mobile is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoading(true);
                            try {
                            // const { data } = await httpClient.post(
                            //   endpoints.auth.forgotPassword(),
                            //   {
                            //     mobile: values.mobile,
                            //   }
                            // );
                            // toast(data.message, {
                            //   type: "success",
                            //   toastId: "auth-otp-success",
                            // });
                            // setStep(2);
                            } catch (error) {
                                ;
                                if ((ref = error.response.data) === null || ref === void 0 ? void 0 : ref.errors) {
                                    (0,react_toastify_esm/* toast */.Am)(Object.values(error.response.data.errors)[0][0], {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                } else {
                                    (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                }
                            }
                            setLoading(false);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var changePasswordFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            otp: "",
            newPassword: "",
            confirmPassword: ""
        },
        validationSchema: yup_es/* object */.Ry({
            otp: yup_es/* string */.Z_().required("OTP is required"),
            newPassword: yup_es/* string */.Z_().required("Password is required"),
            confirmPassword: yup_es/* string */.Z_().required("Confirm password is required").oneOf([
                yup_es/* ref */.iH("newPassword"),
                null
            ], "Passwords must match")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoading(true);
                            try {
                            // const { data } = await httpClient.post(
                            //   endpoints.auth.changePassword(),
                            //   {
                            //     mobile: otpFormik.values.mobile,
                            //     otp: values.otp,
                            //     new_password: values.newPassword,
                            //     confirm_password: values.confirmPassword,
                            //   }
                            // );
                            // toast(data.message, {
                            //   type: "success",
                            //   toastId: "auth-otp-success",
                            // });
                            // dispatch(authActions.setActiveTab("login"));
                            } catch (error) {
                                ;
                                if ((ref = error.response.data) === null || ref === void 0 ? void 0 : ref.errors) {
                                    (0,react_toastify_esm/* toast */.Am)(Object.values(error.response.data.errors)[0][0], {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                } else {
                                    (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                        type: "error",
                                        toastId: "auth-otp-error"
                                    });
                                }
                            }
                            setLoading(false);
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forgotpassword_module_default()).login_container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).login_image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/EXfVWvIz5SFqWvT8MjQ2kNZT0z7fLpusbEtpVMCo.jpeg",
                    alt: "Login image",
                    width: 399,
                    height: 532
                })
            }),
            step == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).contact_form_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: otpFormik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Forgot Password"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "text",
                                    placeholder: "Mobile No."
                                }, otpFormik.getFieldProps("mobile"))),
                                otpFormik.touched.mobile && otpFormik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: otpFormik.errors.mobile
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            role: "button",
                            "aria-label": "Send OTP",
                            className: (forgotpassword_module_default()).submit_btn,
                            type: "submit",
                            disabled: loading,
                            children: [
                                "Send OTP ",
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    size: "sm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "New here?",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return dispatch(auth/* authActions.setActiveTab */.YV.setActiveTab("register"));
                                            },
                                            className: "".concat((forgotpassword_module_default()).new_here, " ", "ms-1 pointer"),
                                            children: "Click to register"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            step == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).contact_form_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: changePasswordFormik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Forgot Password"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "text",
                                    placeholder: "OTP",
                                    autoComplete: "one-time-code"
                                }, changePasswordFormik.getFieldProps("otp"))),
                                changePasswordFormik.touched.otp && changePasswordFormik.errors.otp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: changePasswordFormik.errors.otp
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "password",
                                    placeholder: "New Password",
                                    autoComplete: "new-password"
                                }, changePasswordFormik.getFieldProps("newPassword"))),
                                changePasswordFormik.touched.newPassword && changePasswordFormik.errors.newPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: changePasswordFormik.errors.newPassword
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "password",
                                    placeholder: "Confirm Password",
                                    autoComplete: "new-password"
                                }, changePasswordFormik.getFieldProps("confirmPassword"))),
                                changePasswordFormik.touched.confirmPassword && changePasswordFormik.errors.confirmPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: changePasswordFormik.errors.confirmPassword
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            role: "button",
                            "aria-label": "Change Password",
                            className: (forgotpassword_module_default()).submit_btn,
                            type: "submit",
                            disabled: loading,
                            children: [
                                "Change Password",
                                " ",
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    size: "sm"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var forgot_password_form = (ForgotPasswordForm);

// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./src/utils/regex.ts
var regex = __webpack_require__(1233);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./src/lib/tryOnTracking.ts
var tryOnTracking = __webpack_require__(68763);
// EXTERNAL MODULE: ./node_modules/react-otp-input/lib/index.esm.js
var index_esm = __webpack_require__(58386);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
;// CONCATENATED MODULE: ./src/components/auth/login-form.tsx






















var RESEND_OTP_INTERVAL_SECONDS = 30;
var LoginForm = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), sendOtpLoading = ref1[0], setSendOtpLoading = ref1[1];
    var ref2 = (0,react.useState)(1), step = ref2[0], setStep = ref2[1];
    var ref3 = (0,react.useState)(false), otp_uid = ref3[0], setUid = ref3[1];
    var ref4 = (0,react.useState)(null), otpData = ref4[0], setOTPData = ref4[1];
    var ref5 = (0,react.useState)(false), consent = ref5[0], setConsent = ref5[1];
    var ref6 = (0,react.useState)(0), resendTimeout = ref6[0], setResendTimeout = ref6[1];
    (0,react.useEffect)(function() {
        if (resendTimeout > 0) {
            var timer = setInterval(function() {
                setResendTimeout(resendTimeout - 1);
            }, 1000);
            return function() {
                return clearInterval(timer);
            };
        }
    }, [
        resendTimeout
    ]);
    var isConcent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(token) {
            var data, ref, user;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.auth.getConsentForm */.Z.auth.getConsentForm(), {
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        });
                    case 3:
                        data = _ctx.sent.data;
                        (0,lib.setCookies)("token", token, {
                            path: "/"
                        });
                        _ctx.next = 7;
                        return dispatch((0,auth/* fetchAuthUser */.zA)());
                    case 7:
                        ref = _ctx.sent;
                        user = ref.payload;
                        (0,react_toastify_esm/* toast */.Am)("Welcome " + user.name, {
                            type: "success",
                            toastId: "auth-login-success"
                        });
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Sign in ", {
                                source: "web",
                                platform: "senco"
                            });
                            (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                "pk^mobile": user === null || user === void 0 ? void 0 : user.mobile,
                                SENCO_USER: "yes"
                            });
                            window.smartech("identify", user === null || user === void 0 ? void 0 : user.mobile);
                        }
                        dispatch((0,cart/* fetchCartItems */.Vw)());
                        dispatch((0,wishlist/* fetchWishlistItems */.nf)(user.id));
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(false));
                        (0,tryOnTracking/* initTryOnTracking */.j)(user.id);
                        if (data.status) {
                            // setStep(3);
                            dispatch(auth/* authActions.setIsConsentModalOpen */.YV.setIsConsentModalOpen(true));
                        }
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 21:
                        setLoading(false);
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    18
                ]
            ]);
        }));
        return function isConcent(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var statusChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type) {
            var data, ref, user, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return http_client/* default.post */.Z.post(endpoints/* default.auth.updateConsentForm */.Z.auth.updateConsentForm(), {
                            status: type
                        }, {
                            headers: {
                                Authorization: "Bearer ".concat(otpData.access_token)
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        if (!data.status) {
                            _ctx.next = 19;
                            break;
                        }
                        (0,lib.setCookies)("token", otpData.access_token, {
                            path: "/"
                        });
                        _ctx.next = 9;
                        return dispatch((0,auth/* fetchAuthUser */.zA)());
                    case 9:
                        ref = _ctx.sent;
                        user = ref.payload;
                        (0,react_toastify_esm/* toast */.Am)("Welcome " + user.name, {
                            type: "success",
                            toastId: "auth-login-success"
                        });
                        if (window.Moengage) {
                            window.Moengage.track_event("Login", {
                                mobile: user.mobile
                            });
                            window.Moengage.add_first_name(user.name);
                            window.Moengage.add_mobile(user.mobile);
                            window.Moengage.add_unique_user_id(user.uuid);
                            if (user.email) {
                                window.Moengage.add_email(user.email);
                            }
                        }
                        if (window.smartech) {
                            (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                "pk^mobile": user === null || user === void 0 ? void 0 : user.mobile,
                                SENCO_USER: "yes"
                            });
                            window.smartech("identify", user === null || user === void 0 ? void 0 : user.mobile);
                            (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Sign in ", {
                                source: "web",
                                platform: "senco"
                            });
                        }
                        dispatch((0,cart/* fetchCartItems */.Vw)());
                        dispatch((0,wishlist/* fetchWishlistItems */.nf)(user.id));
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(false));
                        (0,tryOnTracking/* initTryOnTracking */.j)(user.id);
                        dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(false));
                    case 19:
                        _ctx.next = 26;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        if ((ref1 = _ctx.t0.response.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
                            (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "auth-consent-error"
                            });
                        } else {
                            (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                type: "error",
                                toastId: "auth-consent-error"
                            });
                        }
                        setLoading(false);
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    21
                ]
            ]);
        }));
        return function statusChange(type) {
            return _ref.apply(this, arguments);
        };
    }();
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            mobile: ""
        },
        validationSchema: yup_es/* object */.Ry({
            mobile: yup_es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!values.mobile.trim()) {
                                _ctx.next = 20;
                                break;
                            }
                            setSendOtpLoading(true);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.loginSendOtp */.Z.auth.loginSendOtp(), {
                                mobile: values.mobile
                            });
                        case 5:
                            data = _ctx.sent.data;
                            setUid(data.otp_uuid);
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            setStep(2);
                            setResendTimeout(RESEND_OTP_INTERVAL_SECONDS);
                            ;
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](2);
                            ;
                            if ((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        case 17:
                            setSendOtpLoading(false);
                            _ctx.next = 21;
                            break;
                        case 20:
                            {
                                (0,react_toastify_esm/* toast */.Am)("Please enter your registered mobile number", {
                                    type: "error",
                                    toastId: "auth-login-error"
                                });
                            }
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        13
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var otpFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            otp: ""
        },
        validationSchema: yup_es/* object */.Ry({
            otp: yup_es/* string */.Z_().required("OTP is required").min(6, "Must be exactly 6 digits").max(6, "Must be exactly 6 digits")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoading(true);
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.loginVerifyOtp */.Z.auth.loginVerifyOtp(), {
                                mobile: formik.values.mobile,
                                otp: values.otp,
                                otp_uuid: otp_uid
                            });
                        case 4:
                            data = _ctx.sent.data;
                            setOTPData(data);
                            isConcent(data === null || data === void 0 ? void 0 : data.access_token);
                            _ctx.next = 13;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            if ((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) {
                                (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        case 13:
                            setLoading(false);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        9
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var handleResendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(resendTimeout > 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setSendOtpLoading(true);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return http_client/* default.post */.Z.post(endpoints/* default.auth.loginSendOtp */.Z.auth.loginSendOtp(), {
                            mobile: formik.values.mobile
                        });
                    case 6:
                        data = _ctx.sent.data;
                        setUid(data.otp_uuid);
                        (0,react_toastify_esm/* toast */.Am)(data.message, {
                            type: "success",
                            toastId: "auth-otp-success"
                        });
                        setResendTimeout(RESEND_OTP_INTERVAL_SECONDS);
                        _ctx.next = 16;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        if ((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) {
                            (0,react_toastify_esm/* toast */.Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "auth-otp-error"
                            });
                        } else {
                            (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                type: "error",
                                toastId: "auth-otp-error"
                            });
                        }
                    case 16:
                        setSendOtpLoading(false);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    12
                ]
            ]);
        }));
        return function handleResendOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forgotpassword_module_default()).login_container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).login_image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/EXfVWvIz5SFqWvT8MjQ2kNZT0z7fLpusbEtpVMCo.jpeg",
                    alt: "Login image",
                    width: 399,
                    height: 532
                })
            }),
            step == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).contact_form_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: formik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "tel",
                                    placeholder: "Mobile No.",
                                    autoComplete: "off",
                                    maxLength: 10
                                }, formik.getFieldProps("mobile"))),
                                formik.touched.mobile && formik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: formik.errors.mobile
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            role: "button",
                            "aria-label": "Request OTP",
                            className: (forgotpassword_module_default()).submit_btn,
                            type: "submit",
                            disabled: loading || sendOtpLoading,
                            children: [
                                "Request OTP",
                                " ",
                                sendOtpLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    size: "sm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-7",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "New here?",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return dispatch(auth/* authActions.setActiveTab */.YV.setActiveTab("register"));
                                            },
                                            className: "".concat((forgotpassword_module_default()).new_here, " ", "ms-1 pointer"),
                                            children: "Click to register"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            step == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).signup_form_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                    onSubmit: otpFormik.handleSubmit,
                    children: step == 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "pt-5",
                                children: "Verify OTP"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "form-item pt-2 pb-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                                        value: otpFormik.values.otp,
                                        onChange: function(val) {
                                            return otpFormik.setFieldValue("otp", val);
                                        },
                                        numInputs: 6,
                                        renderSeparator: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "-"
                                        }),
                                        renderInput: function(props) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, props));
                                        },
                                        containerStyle: {
                                            justifyContent: "space-between"
                                        },
                                        inputStyle: {
                                            width: "2rem"
                                        },
                                        inputType: "number"
                                    }),
                                    otpFormik.touched.otp && otpFormik.errors.otp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        className: "text-danger",
                                        children: otpFormik.errors.otp
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (forgotpassword_module_default()).submit_btn,
                                type: "submit",
                                disabled: loading,
                                children: [
                                    "Verify ",
                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                        animation: "border",
                                        size: "sm"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: (forgotpassword_module_default()).resendotp,
                                type: "button",
                                onClick: handleResendOtp,
                                disabled: resendTimeout > 0,
                                children: [
                                    "Resend OTP ",
                                    resendTimeout > 0 && "(".concat(resendTimeout, "s)"),
                                    " ",
                                    sendOtpLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                        animation: "border",
                                        size: "sm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var login_form = (LoginForm);

// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./src/lib/ppixel.ts
var ppixel = __webpack_require__(55763);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/components/auth/register-form.tsx




















var RegisterForm = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var ref = (0,react.useState)(1), step = ref[0], setStep = ref[1];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(false), otp_uid = ref2[0], setUid = ref2[1];
    var currentDate = moment_timezone_default()().format("DD-MM-YYYY");
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            name: "",
            email: "",
            mobile: "",
            pincode: ""
        },
        validationSchema: yup_es/* object */.Ry({
            name: yup_es/* string */.Z_().required("Name is required"),
            email: yup_es/* string */.Z_().required("Email is required").email("Email is invalid"),
            // consent: Yup.boolean()
            //   .oneOf([true], "You must accept the personal data processing consent")
            //   .required("You must accept the personal data processing consent"),
            mobile: yup_es/* string */.Z_().matches(regex/* phoneRegExp */.O, "Mobile number is not valid").test("len", "Mobile number needs to be exactly 10 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 10;
            }).required("Mobile is required"),
            pincode: yup_es/* string */.Z_().required("Pincode is required").matches(/^\d{6}$/, "Invalid pincode. Must be a 6-digit number")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoading(true);
                            if (window.Moengage) {
                                window.Moengage.track_event("Registration Initiated", {
                                    mobile: values.mobile,
                                    name: values.name,
                                    email: values.email,
                                    pincode: values.pincode,
                                    platform: "website"
                                });
                            }
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.sendOtp */.Z.auth.sendOtp(), {
                                mobile: values.mobile,
                                email: values.email,
                                pincode: values.pincode
                            });
                        case 5:
                            data = _ctx.sent.data;
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            if (window.Moengage) {
                                window.Moengage.track_event("Registration Submitted", {
                                    mobile: values.mobile,
                                    name: values.name,
                                    email: values.email,
                                    pincode: values.pincode,
                                    platform: "website"
                                });
                            }
                            setStep(2);
                            setUid(data.otp_uuid);
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](2);
                            ;
                            if ((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) {
                                ;
                                (0,react_toastify_esm/* toast */.Am)((ref1 = _ctx.t0.response.data) === null || ref1 === void 0 ? void 0 : ref1.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        case 16:
                            setLoading(false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        12
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    var otpFormik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            otp: ""
        },
        validationSchema: yup_es/* object */.Ry({
            otp: yup_es/* string */.Z_().required("OTP is required")
        }),
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                var data, ref, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setLoading(true);
                            if (window.Moengage) {
                                window.Moengage.track_event("Verification Initiated", {
                                    mobile: formik.values.mobile,
                                    platform: "website"
                                });
                            }
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return http_client/* default.post */.Z.post(endpoints/* default.auth.signup */.Z.auth.signup(), {
                                name: formik.values.name,
                                mobile: formik.values.mobile,
                                email: formik.values.email,
                                pincode: formik.values.pincode,
                                otp: values.otp,
                                // consent: formik.values.consent,
                                otp_uuid: otp_uid,
                                source: "signup_popup"
                            });
                        case 5:
                            data = _ctx.sent.data;
                            (0,react_toastify_esm/* toast */.Am)(data.message, {
                                type: "success",
                                toastId: "auth-otp-success"
                            });
                            if (window.Moengage) {
                                window.Moengage.track_event("Verification Submitted", {
                                    mobile: formik.values.mobile,
                                    platform: "website"
                                });
                                window.Moengage.track_event("Registration Completed", {
                                    mobile: formik.values.mobile,
                                    platform: "website"
                                });
                            }
                            if (window.smartech) {
                                (0,unbxd/* unbxdCusEngTrackUser */.nV)({
                                    "pk^mobile": formik.values.mobile,
                                    NAME: formik.values.name,
                                    email: formik.values.email,
                                    PINCODE: formik.values.pincode,
                                    SENCO_USER: "yes",
                                    REGISTRATION_DATE_SENCO: currentDate
                                });
                                window.smartech("identify", formik.values.mobile);
                                setTimeout(function() {
                                    (0,unbxd/* unbxdCusEngTrackEvent */.$z)("Registration", {
                                        source: "web",
                                        platform: "senco"
                                    });
                                }, 200);
                            }
                            (0,fpixel/* fbqTrackEvent */.dK)("CompleteRegistration", {
                                status: "registered"
                            });
                            (0,ppixel/* ptrackEvent */.rn)("signup", {
                                event_id: "signup_".concat(Date.now())
                            });
                            (0,react_toastify_esm/* toast */.Am)("Registration Successful! Please login to continue", {
                                type: "success",
                                toastId: "auth-registration-success"
                            });
                            dispatch(auth/* authActions.setActiveTab */.YV.setActiveTab("login"));
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            ;
                            if ((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) {
                                ;
                                (0,react_toastify_esm/* toast */.Am)((ref1 = _ctx.t0.response.data) === null || ref1 === void 0 ? void 0 : ref1.message, {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            } else {
                                (0,react_toastify_esm/* toast */.Am)("Something went wrong! Try again!", {
                                    type: "error",
                                    toastId: "auth-otp-error"
                                });
                            }
                        case 19:
                            setLoading(false);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forgotpassword_module_default()).sign_up_container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).login_image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/EXfVWvIz5SFqWvT8MjQ2kNZT0z7fLpusbEtpVMCo.jpeg",
                    alt: "Login image",
                    width: 399,
                    height: 532
                })
            }),
            step == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).signup_form_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: formik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Create new account"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "text",
                                    placeholder: "Name"
                                }, formik.getFieldProps("name"))),
                                formik.touched.name && formik.errors.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: formik.errors.name
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "email",
                                    placeholder: "Email",
                                    autoComplete: "new-email"
                                }, formik.getFieldProps("email"))),
                                formik.touched.email && formik.errors.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: formik.errors.email
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "text",
                                    placeholder: "Mobile No.",
                                    maxLength: 10
                                }, formik.getFieldProps("mobile"))),
                                formik.touched.mobile && formik.errors.mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: formik.errors.mobile
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "text",
                                    placeholder: "Pincode"
                                }, formik.getFieldProps("pincode"))),
                                formik.touched.pincode && formik.errors.pincode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: formik.errors.pincode
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: (forgotpassword_module_default()).submit_btn,
                            type: "submit",
                            disabled: loading,
                            children: [
                                "Register ",
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    size: "sm"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Already have an account?",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return dispatch(auth/* authActions.setActiveTab */.YV.setActiveTab("login"));
                                            },
                                            className: "ms-1 pointer",
                                            children: "Click to login."
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            step == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (forgotpassword_module_default()).signup_form_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: otpFormik.handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "Verify OTP"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "form-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                    type: "text",
                                    placeholder: "OTP"
                                }, otpFormik.getFieldProps("otp"))),
                                otpFormik.touched.otp && otpFormik.errors.otp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                    className: "text-danger",
                                    children: otpFormik.errors.otp
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            role: "button",
                            "aria-label": "Verify",
                            className: (forgotpassword_module_default()).submit_btn,
                            type: "submit",
                            disabled: loading,
                            children: [
                                "Verify ",
                                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                    animation: "border",
                                    size: "sm"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var register_form = (RegisterForm);

;// CONCATENATED MODULE: ./src/components/auth/auth-modal.tsx









var AuthModal = function() {
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: authState.isModalOpen,
        onHide: function() {
            return dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(false));
        },
        dialogClassName: "modal-lg border-0",
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        className: "high-z-index",
        backdropClassName: "high-z-index",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                className: "p-0",
                closeButton: true,
                onClick: function() {
                    return dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(false));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: "p-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "contact-box",
                    children: [
                        authState.activeTab == "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(login_form, {}),
                        authState.activeTab == "register" && /*#__PURE__*/ (0,jsx_runtime.jsx)(register_form, {}),
                        authState.activeTab == "forgot-password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(forgot_password_form, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var auth_modal = (AuthModal);


/***/ }),

/***/ 29543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89936);
/* harmony import */ var _store_slices_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40034);
/* harmony import */ var _store_slices_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45066);
/* harmony import */ var _lib_ga4__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77981);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(36968);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var _components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80062);
/* harmony import */ var _components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74231);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82175);
/* harmony import */ var _api_endpoints__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3557);
/* harmony import */ var _api_http_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55642);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40782);


















var BillingAddressModal = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), billingAddressLoading = ref[0], setBillingAddressLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([
        {
            code: "IND",
            name: "India"
        }
    ]), country = ref1[0], setCountry = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]), state = ref2[0], setState = ref2[1];
    var dispatch = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .T)();
    var authState = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .selectAuth */ .Hz);
    var cartState = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(_store_slices_cart__WEBPACK_IMPORTED_MODULE_4__/* .selectCart */ .KY);
    var hasAccountId = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        var ref;
        return !!((ref = authState.user) === null || ref === void 0 ? void 0 : ref.account_id);
    }, [
        authState.user
    ]);
    var formikBillingAddress = (0,formik__WEBPACK_IMPORTED_MODULE_8__/* .useFormik */ .TA)({
        initialValues: {
            country: "",
            state: "",
            city: "",
            pin: "",
            address: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_7__/* .object */ .Ry({
            country: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().required("Country is required"),
            state: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().required("State is required"),
            city: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().required("City is required"),
            pin: yup__WEBPACK_IMPORTED_MODULE_7__/* .number */ .Rx().typeError("Please give number").required("Pincode is required").test("len", "Pincode needs to be exactly 6 digits", function(val) {
                return (val === null || val === void 0 ? void 0 : val.toString().length) === 6;
            }),
            address: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().required("Address is required")
        }),
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
                var ref, ref1;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setBillingAddressLoading(true);
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return _api_http_client__WEBPACK_IMPORTED_MODULE_10__/* ["default"].put */ .Z.put(_api_endpoints__WEBPACK_IMPORTED_MODULE_9__/* ["default"].auth.billingAddressUpdate */ .Z.auth.billingAddressUpdate(), values);
                        case 4:
                            (0,react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast */ .Am)("Billing Address Updated Successfully", {
                                type: "success"
                            });
                            dispatch((0,_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchAuthUser */ .zA)());
                            dispatch(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .authActions.setBillingModalOpen */ .YV.setBillingModalOpen(false));
                            // Track GA4 add_shipping_info event for billing address
                            (0,_lib_ga4__WEBPACK_IMPORTED_MODULE_13__/* .trackAddShippingInfo */ .EI)({
                                currency: "INR",
                                value: cartState.total || 0,
                                shipping_tier: "Billing",
                                items: (0,_lib_ga4__WEBPACK_IMPORTED_MODULE_13__/* .formatCartItemsForGA4 */ .fT)(cartState.items || [])
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            if (((ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status) === 422) {
                                ;
                                Object.keys((ref1 = _ctx.t0.response.data) === null || ref1 === void 0 ? void 0 : ref1.errors).map(function(v) {
                                    (0,react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast */ .Am)(_ctx.t0.response.data.errors[v][0], {
                                        type: "warning"
                                    });
                                });
                            } else {
                                (0,react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast */ .Am)("Something went wrong", {
                                    type: "warning"
                                });
                            }
                        case 14:
                            setBillingAddressLoading(false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        10
                    ]
                ]);
            }));
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    // const countryLoad = async () => {
    //   const { data } = await httpClient.get(endpoints.countries());
    //   setCountry(data.data);
    // };
    var stateLoad = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(country, value) {
            var data;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _api_http_client__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get */ .Z.get(_api_endpoints__WEBPACK_IMPORTED_MODULE_9__/* ["default"].state */ .Z.state(country));
                    case 2:
                        data = _ctx.sent.data;
                        setState(data.data);
                        formikBillingAddress.setFieldValue("state", value);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function stateLoad(country, value) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
    // countryLoad();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        var ref, ref1;
        setState([]);
        if (formikBillingAddress === null || formikBillingAddress === void 0 ? void 0 : (ref = formikBillingAddress.values) === null || ref === void 0 ? void 0 : (ref1 = ref.country) === null || ref1 === void 0 ? void 0 : ref1.length) {
            stateLoad(formikBillingAddress.values.country, "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formikBillingAddress.values.country
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        show: authState.billingModalOpen,
        onHide: function() {
            return dispatch(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .authActions.setBillingModalOpen */ .YV.setBillingModalOpen(false));
        },
        dialogClassName: "modal-lg border-0",
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Header */ .Z.Header, {
                className: "p-0",
                closeButton: true,
                onClick: function() {
                    return dispatch(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .authActions.setBillingModalOpen */ .YV.setBillingModalOpen(false));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Body */ .Z.Body, {
                className: "p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().new_address),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().new_add_form),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().bill_head),
                                    children: "Billing Address"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                    onSubmit: formikBillingAddress.handleSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "col-md-6 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                            className: "required",
                                                            children: [
                                                                "Country ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("select", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().input_text)
                                                        }, formikBillingAddress.getFieldProps("country")), {
                                                            disabled: hasAccountId,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select"
                                                                }),
                                                                !!country.length && (country === null || country === void 0 ? void 0 : country.map(function(v) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                        value: v.code,
                                                                        children: v.name
                                                                    }, v.code);
                                                                }))
                                                            ]
                                                        })),
                                                        formikBillingAddress.touched.country && formikBillingAddress.errors.country ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                            className: "text-danger",
                                                            children: formikBillingAddress.errors.country
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "col-md-6 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                            className: "required",
                                                            children: [
                                                                "State ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("select", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().input_text)
                                                        }, formikBillingAddress.getFieldProps("state")), {
                                                            disabled: hasAccountId,
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                    value: "",
                                                                    children: "Select"
                                                                }),
                                                                !!state.length && state.map(function(v) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                        value: v.code,
                                                                        children: v.name
                                                                    }, v.code);
                                                                })
                                                            ]
                                                        })),
                                                        formikBillingAddress.touched.state && formikBillingAddress.errors.state ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                            className: "text-danger",
                                                            children: formikBillingAddress.errors.state
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "col-md-6 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                            className: "required",
                                                            children: [
                                                                "City ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                                            type: "text",
                                                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().input_text)
                                                        }, formikBillingAddress.getFieldProps("city")), {
                                                            disabled: hasAccountId
                                                        })),
                                                        formikBillingAddress.touched.city && formikBillingAddress.errors.city ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                            className: "text-danger",
                                                            children: formikBillingAddress.errors.city
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "col-md-6 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                            className: "required",
                                                            children: [
                                                                "Pincode ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                                            type: "text",
                                                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().input_text),
                                                            maxLength: 6
                                                        }, formikBillingAddress.getFieldProps("pin")), {
                                                            disabled: hasAccountId
                                                        })),
                                                        formikBillingAddress.touched.pin && formikBillingAddress.errors.pin ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                            className: "text-danger",
                                                            children: formikBillingAddress.errors.pin
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: "col-md-12 mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                            className: "required",
                                                            children: [
                                                                "Address ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("sup", {
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                                                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().input_textarea),
                                                            rows: 2
                                                        }, formikBillingAddress.getFieldProps("address")), {
                                                            disabled: hasAccountId
                                                        })),
                                                        formikBillingAddress.touched.address && formikBillingAddress.errors.address ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                            className: "text-danger",
                                                            children: formikBillingAddress.errors.address
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        }),
                                        !hasAccountId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                            type: "submit",
                                            className: (_components_profile_update_updateprofile_updateprofile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().save),
                                            disabled: billingAddressLoading,
                                            children: [
                                                "Save",
                                                " ",
                                                billingAddressLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    animation: "border",
                                                    size: "sm"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        " "
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BillingAddressModal);


/***/ }),

/***/ 38956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89936);
/* harmony import */ var _store_slices_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40034);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35005);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6212);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _assets_images_logo_pop_new_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47441);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _api_http_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55642);
/* harmony import */ var _api_endpoints__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3557);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40782);















var CustomerConsent = function() {
    var dispatch = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .T)();
    var authState = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .selectAuth */ .Hz);
    var statusChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type) {
            var data, ref;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _api_http_client__WEBPACK_IMPORTED_MODULE_9__/* ["default"].post */ .Z.post(_api_endpoints__WEBPACK_IMPORTED_MODULE_10__/* ["default"].auth.updateConsentForm */ .Z.auth.updateConsentForm(), {
                            status: type
                        });
                    case 3:
                        data = _ctx.sent.data;
                        dispatch(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .authActions.setIsConsentModalOpen */ .YV.setIsConsentModalOpen(false));
                        window.location.reload();
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        if ((ref = _ctx.t0.response.data) === null || ref === void 0 ? void 0 : ref.message) {
                            (0,react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast */ .Am)(_ctx.t0.response.data.message, {
                                type: "error",
                                toastId: "auth-consent-error"
                            });
                        } else {
                            (0,react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast */ .Am)("Something went wrong! Try again!", {
                                type: "error",
                                toastId: "auth-consent-error"
                            });
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function statusChange(type) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        show: authState.consentModalOpen,
        dialogClassName: "modal-lg border-0 customer_consent__pop",
        "aria-labelledby": "contained-modal-title-vcenter",
        centered: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Header */ .Z.Header, {
                className: "p-0 custom_border_0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Body */ .Z.Body, {
                className: "p-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "customer_consent_main ",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "border-pop over-height",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "logo_pop",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    src: _assets_images_logo_pop_new_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "heading mb-3 mt-3",
                                children: "CONSENT NOTICE"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    "Senco Gold Limited (hereinafter referred to as “Company”, “We”, “Us”, or “Our”), incorporated under the Companies Act, 1956 (CIN: L36911WB1994PLC064637), with its registered office located at Diamond Prestige, 41A A.J.C. Bose Road, 10th Floor, Unit No. 1001, Kolkata – 700017, West Bengal, India, respects the privacy of any person who accesses or uses Our Website/Application (hereinafter referred to as “You” or “Your”) and is committed to protecting your Digital Personal Data. This notice applies to the processing of Personal Data collected in digital form or any non-digital form which is digitised subsequently.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    "In order to comply with the Digital Personal Data Protection Act, 2023 (“DPDP Act”) and the rules framed thereunder and to nurture Our association, we would be collecting and processing Your Digital Personal Data. For this data collection and its processing, we need Your explicit consent.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    "The purpose of processing Your Digital Personal Data is to support the services provided by the Company or its affiliates to You (please visit Our website for a list of services offered by the Company) or to facilitate Your interactions with the Company in roles, including but not limited to, an employee or vendor/supplier. There may be instances where Your Digital Personal Data needs to be shared with regulators, business associates, or payment gateways, resulting in Your data being transferred beyond Company’s control. This sharing may also be necessitated now or in future as per the requirement and in accordance with the applicable laws/regulations in India, as may be amended from time to time.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    "You reserve the right to file a complaint with the Company regarding any grievances arising from the processing of Your Digital Personal Data, which shall be directed to the Grievance Officer, as detailed in Our Policy. Should the grievance remain unresolved through Our grievance redressal mechanism, You further retain the right to approach the Data Protection Board of India with a complaint, as outlined in the provisions of the DPDP Act.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    "All the capitalised terms used in this Consent Notice shall have the same meaning assigned to them as in Company’s Policy. (“Policy”).",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "heading mb-3 mt-3",
                                children: "Declaration of Understanding - Data Processing Policies:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "1"
                                    }),
                                    ". I understand that my Digital Personal Data may be collected only with my valid consent, and that it may be processed only in accordance with the Policy."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "2"
                                    }),
                                    ". I agree to provide the following information to Company during registration on our App/ Website or usage of our App/ Website or both, as and when necessary, including, but not limited to:"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                    className: "list_two_liv",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                    className: "pb-2 d-block",
                                                    children: "Your information:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                    className: "list_two_liv",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Gender"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Occupation"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Education"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Address"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Financial information"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Identity proof such as PAN Card, AADHAR Card, Voter ID card etc."
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Previous purchase history from Us"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Consumer durables owned"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Communication details:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                    className: "list_two_liv",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Email address"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Phone number"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Postal address"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Any other contact information"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Device information:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                    className: "list_two_liv",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Operating system"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Operating system providing advertising ID"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "IP address"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Date and time of every user request"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Your usage information with Our devices placed at Our office"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Your internet protocol address"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Behavioural patterns:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                    className: "list_two_liv",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Your active seconds and minutes in Our work database"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Your search history in Our device located at Our office"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Sharing a product or inspiration to social media sites"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Other interactions and dialogues during interactive search"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                    className: "pb-2 pt-2 d-block",
                                                    children: "Non-personal information (THIS TYPE OF INFORMATION DOES NOT IDENTIFY YOU PERSONALLY)"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                                    className: "list_two_liv",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "The pages you visit"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Links you click"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Advertisements you view"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Number of times you access Our page"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Your opinion on Our services, products, features that We offer"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Operating system"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Browser type"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Internet service provider"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Aggregate user data"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Software and hardware attributes"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                            children: "Number of clicks"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    " ",
                                    "If You communicate with Us, by, for example, email or letter, any information provided in such communication may be collected and stored by Us."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "3"
                                    }),
                                    ". Specifically, You understand that Your Digital Personal Data may be processed for any or all of the following purposes, as may be applicable:"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "ps-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(i) Facilitating personnel management, including verification, compensation management (such as bank details for salary disbursement), performance management, compliance with legal obligations, health and safety management, training and development, and internal communications."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(ii) Fulfilling customer orders placed, including but not limited to, managing payment transactions, coordinating shipping logistics, and facilitating the delivery of goods."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(iii) Facilitating communication regarding order confirmations, invoices, and receipts for purchases made both online and offline."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(iv) Communicating updates pertaining to the status of orders or delivery schedules."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(v) Managing inquiries, complaints, or requests for assistance."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(vi) Disseminating newsletters and promotional communications regarding upcoming events, sales, and the introduction of new products."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(vii) Soliciting customer feedback through surveys and rating mechanisms."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(viii) Enrolling in loyalty or rewards programs and thereby tracking points or rewards accumulated through purchases made both online and offline."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(ix) Complying with applicable legal obligations, including but not limited to tax reporting, audit requirements, or responses to requests from law enforcement authorities."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(x) Analysing market trends, conducting market research, and improving overall business strategies, utilizing information gathered from both online and offline sales."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xi) Detecting and preventing fraudulent transactions or unauthorized access to customer accounts, thereby safeguarding both the customer and the brand across all sales channels."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xii) Sharing information with third-party service providers for limited purposes of operational and logistical functions to complete the order."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xiii) Facilitating linking of customer accounts with social media platforms for the purpose of sharing purchases or promotional materials, whether derived from online or offline transactions."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xiv) Facilitating effective communication, assessing service quality, and managing supply chain operations for purposes related to the business relationship, including but not limited to entering into and managing agreements, evaluating supplier qualifications, processing payments, and ensuring compliance with contractual obligations."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xv) To build up marketing profiles."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xvi) Aiding strategic development, data collection, and business analytics."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xvii) Managing our relationship with advertisers and other partners."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        children: "(xviii) Any other grounds as per applicable law."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "4"
                                    }),
                                    ". I understand that I have certain rights that I enjoy as a data principal over my Digital Personal Data, in relation to its collection, use and processing. These rights, inter alia, relate to confirmation and access, correction and erasure, objection of processing, grievance redressal and withdrawal of consent. These rights are available to me in the manner set out in the Policy."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "5"
                                    }),
                                    ". I agree that am of lawful age to contract as per applicable laws and I have read and understood the processing requirement with respect to my Digital Personal Data as listed above and provide my free, specific, informed, unconditional and unambiguous consent to the above by signing on the space provided below."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "6"
                                    }),
                                    ". I understand that I have the right to withdraw my consent at any time in the manner specified under the Policy. If I need to withdraw my consent with respect to usage of my Digital Personal Data under Company’s purview, excluding data which has already been shared with the authorities, regulators or business associates and outside the control of the Company at that time, I will inform the Company through the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                                        href: "/account/profile",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                            style: {
                                                color: "#93101d"
                                            },
                                            children: "Consent Withdrawal Form "
                                        })
                                    }),
                                    "as provided on the Website.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "7"
                                    }),
                                    ". I understand that this withdrawal of consent will be implemented as soon as practicable. I also confirm that the Company, while accepting my request for withdrawal of consent, will be allowed to keep such Digital Personal Data as required by the applicable laws and regulations for history and record keeping purposes for a specified period of time.",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                        children: "8"
                                    }),
                                    ". By clicking on “I agree to consent to the processing of my Digital Personal Data” below, I signify agreement to the processing and sharing of my Digital Personal Data with the Company now and in future in order to allow the Company to conduct business or sharing information with business associates or authorities as may be required under different regulations, laws and statues of India and outside India, or with such third parties/vendors, as may be applicable and amended from time to time."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "custom-fill",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        "aria-label": "reject",
                                        variant: "dark",
                                        className: "pe-4 ps-4",
                                        onClick: function() {
                                            return statusChange("reject");
                                        },
                                        role: "button",
                                        children: "I do not concent to the proccessing of my Digital Personal Data"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        role: "button",
                                        "aria-label": "accept",
                                        className: "green_button pe-4 ps-4",
                                        onClick: function() {
                                            return statusChange("accept");
                                        },
                                        children: "I concent to the proccessing of my Digital Personal Data"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerConsent);


/***/ }),

/***/ 95117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89936);
/* harmony import */ var _store_slices_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40034);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6212);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _account_selection_modal_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16107);
/* harmony import */ var _account_selection_modal_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_account_selection_modal_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _api_http_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55642);
/* harmony import */ var _api_endpoints__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3557);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40782);













var AccountSelectionModal = function() {
    var ref;
    var dispatch = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .T)();
    var authState = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .selectAuth */ .Hz);
    var update = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return _api_http_client__WEBPACK_IMPORTED_MODULE_7__/* ["default"].put */ .Z.put(_api_endpoints__WEBPACK_IMPORTED_MODULE_8__/* ["default"].auth.profileUpdate */ .Z.auth.profileUpdate(), values);
                    case 3:
                        (0,react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast */ .Am)("Profile Updated Successfully", {
                            type: "success"
                        });
                        dispatch((0,_store_slices_auth__WEBPACK_IMPORTED_MODULE_3__/* .fetchAuthUser */ .zA)());
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast */ .Am)("Something went wrong", {
                            type: "warning"
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function update(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        show: authState.accountSelectionModalOpen,
        dialogClassName: "modal-md",
        centered: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Body */ .Z.Body, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h4", {
                    children: "Choose your default account"
                }),
                (((ref = authState.user) === null || ref === void 0 ? void 0 : ref.duplicate_records) || []).map(function(record, i) {
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "row m-3 p-2 pointer ".concat((_account_selection_modal_module_scss__WEBPACK_IMPORTED_MODULE_12___default().option)),
                        style: {
                            border: "1px solid red",
                            borderRadius: 10
                        },
                        onClick: function() {
                            return update({
                                name: record.name,
                                email: record.email,
                                gender: record.gender
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-md-3 d-flex align-items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                        src: (ref = record.platform) === null || ref === void 0 ? void 0 : ref.logo,
                                        alt: (ref1 = record.platform) === null || ref1 === void 0 ? void 0 : ref1.name,
                                        height: 50,
                                        width: 100
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "col-md-9",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                children: "Platform"
                                            }),
                                            ": ",
                                            (ref2 = record.platform) === null || ref2 === void 0 ? void 0 : ref2.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                children: "Name"
                                            }),
                                            ": ",
                                            record.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                children: "Email"
                                            }),
                                            ": ",
                                            record.email
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                        className: "mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                children: "Gender"
                                            }),
                                            ": ",
                                            record.gender
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountSelectionModal);


/***/ }),

/***/ 77981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ trackAddShippingInfo; },
/* harmony export */   "Mk": function() { return /* binding */ trackViewItemList; },
/* harmony export */   "Ye": function() { return /* binding */ GA4_ITEM_BRAND; },
/* harmony export */   "fT": function() { return /* binding */ formatCartItemsForGA4; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29815);
/**
 * Google Analytics 4 Event Tracking Utilities
 * Reference: https://developers.google.com/analytics/devguides/collection/ga4/reference/events
 */ 
/**
 * Common GA4 item brand constant
 */ var GA4_ITEM_BRAND = "Senco";
/**
 * Format cart items for GA4 ecommerce tracking
 */ var formatCartItemsForGA4 = function(items) {
    return items.map(function(item) {
        var ref, ref1, ref2;
        return {
            item_id: String(item.id),
            item_name: item.name || item.product_name,
            item_brand: GA4_ITEM_BRAND,
            item_category: ((ref = item.data) === null || ref === void 0 ? void 0 : ref.type) ? (ref1 = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(item.data.type).reverse()[0]) === null || ref1 === void 0 ? void 0 : ref1.name_en : undefined,
            item_variant: ((ref2 = item.data) === null || ref2 === void 0 ? void 0 : ref2.purity) || undefined,
            price: item.price || item.product_price,
            quantity: 1
        };
    });
};
/**
 * Track add_shipping_info event
 * Triggered when user adds shipping information (address) during checkout or in profile
 *
 * @param params - Event parameters including cart value, items, and shipping info
 */ var trackAddShippingInfo = function(params) {
    try {
        if ( false || !window.dataLayer) {
            return;
        }
        // Clear previous ecommerce data
        window.dataLayer.push({
            ecommerce: null
        });
        // Push add_shipping_info event
        window.dataLayer.push({
            event: "add_shipping_info",
            ecommerce: {
                currency: params.currency || "INR",
                value: params.value,
                coupon: params.coupon || undefined,
                shipping_tier: params.shipping_tier || "Standard",
                items: params.items
            }
        });
        ;
    } catch (error) {
        ;
    }
};
/**
 * Track view_item_list event
 * Triggered when user views a list of items (category page, search results, etc.)
 *
 * @param params - Event parameters including list ID, name, and items
 */ var trackViewItemList = function(params) {
    try {
        if ( false || !window.dataLayer) {
            return;
        }
        // Clear previous ecommerce data
        window.dataLayer.push({
            ecommerce: null
        });
        // Push view_item_list event
        window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
                item_list_id: params.item_list_id,
                item_list_name: params.item_list_name,
                items: params.items
            }
        });
        ;
    } catch (error) {
        ;
    }
};


/***/ }),

/***/ 1233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ phoneRegExp; }
/* harmony export */ });
var phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;


/***/ }),

/***/ 16107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"account-selection-modal_option__r3ndX"};

/***/ }),

/***/ 80062:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"new_add_form":"updateprofile_new_add_form__A1lxE","input_text":"updateprofile_input_text__a50ji","input_textarea":"updateprofile_input_textarea__pY7M5","save":"updateprofile_save__Op8AE","new_address":"updateprofile_new_address__i4bpX","bill_head":"updateprofile_bill_head__zSjwD","new_address_new":"updateprofile_new_address_new__7Nep0","nav":"updateprofile_nav__1hobM","active":"updateprofile_active__TP8cs"};

/***/ }),

/***/ 6231:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"login_container":"forgotpassword_login_container__n_kHC","login_image":"forgotpassword_login_image__p0nB3","contact_form_wrapper":"forgotpassword_contact_form_wrapper__PHwyF","new_here":"forgotpassword_new_here__f8R6c","submit_btn":"forgotpassword_submit_btn__6RSJ2","signup_form_wrapper":"forgotpassword_signup_form_wrapper__2ckij","sign_up_container":"forgotpassword_sign_up_container__1lr__","resendotp":"forgotpassword_resendotp__mv8vT"};

/***/ })

}]);